import React from 'react';
import { ToastContainer as ReactToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/ToastContainer.css';

const ToastContainer = () => {
  return (
    <ReactToastContainer
      position="bottom-right"
      autoClose={false}
      newestOnTop
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      theme="light"
    />
  );
};

export default ToastContainer;